const storageKey = (key: string) => `@ReactAccessibility:${key}`;

export default storageKey;
